export default __webpack_public_path__ + "static/media/pic33.42046bc3.jpg";